import { MapPdfSummaryComponent } from '~/map/page/mapPdfSummary.component';
import { useToolsStateExportPdfSelector } from '~/store/mapSettings/toolsState/exportPdf/exportPdfToolState.selectors';
import { ExportPdfActiveType } from '~/store/mapSettings/toolsState/exportPdf/exportPdfToolState.state';

type PdfReportPageProps = Readonly<{
  mapShareId: string;
  mapId: number | null;
}>;

export const ReportPageComponent = (props: PdfReportPageProps) => {
  const reportData = useToolsStateExportPdfSelector();

  return (
    <div>
      <div>PDF report for mapShareId: {props.mapShareId}</div>
      <div>Map ID: {props.mapId}</div>
      <div>{reportData.params?.type === ExportPdfActiveType.Location ? reportData.params.data.title : 'No title for this report'}</div>
      <MapPdfSummaryComponent />
    </div>
  );
};
